import React from "react";
import "./musicNoteAnimation.scss";
import { Box, Stack, Typography } from "@mui/material";
import { Images } from "../../assets/common";
import { truncate } from "../../constants/function";
export default function MusicNoteAnimation({ song }) {
  return (
    // <div class="muzieknootjes">
    //   <div class="noot-1">&#9835; &#9833;</div>
    //   <div class="noot-2">&#9833;</div>
    //   <div class="noot-3">&#9839; &#9834;</div>
    //   <div class="noot-4">&#9834;</div>
    // </div>
    <Stack direction="column" className="_song_animation_bar">
      <Stack direction="row" alignItems="center" spacing={1}>
        <img
          style={{ width: "18px", height: "18px", borderRadius: "50%" }}
          src={song?.thumbnailImg.filePath || Images.user_dummy}
          alt=""
        />
        <Typography className="fs-14 fade-text-60">
          {truncate(song?.song, 15)}
        </Typography>
        {/* <Typography className="fs-11 fade-text">
          ({truncate(song?.artist, 15)})
        </Typography> */}
      </Stack>
      <img className="_bar" src={Images.song_animation} alt="" />
    </Stack>
  );
}
